import { ManualInstallation } from 'onboarding/llm-analytics/manual.tsx';
import { OnboardingContentWrapper } from 'components/Docs/OnboardingContentWrapper';
import GenerationEvent from "../../../../contents/docs/llm-analytics/_snippets/generation-event.mdx";
import TraceEvent from "../../../../contents/docs/llm-analytics/_snippets/trace-event.mdx";
import SpanEvent from "../../../../contents/docs/llm-analytics/_snippets/span-event.mdx";
import EmbeddingEvent from "../../../../contents/docs/llm-analytics/_snippets/embedding-event.mdx";
import * as React from 'react';
export default {
  ManualInstallation,
  OnboardingContentWrapper,
  GenerationEvent,
  TraceEvent,
  SpanEvent,
  EmbeddingEvent,
  React
};